<template>
  <div
    class=""
    style="display: flex; flex-direction: column; height: 100%; padding: 1px"
    :id="componentId"
  >
    <div style="display: flex; flex-direction: row; flex: 1; padding-top: 2px">
      <div
        style="display: flex; flex-direction: column"
        v-for="star in palace.stars"
        :key="star.name"
        :style="{
          'font-size': fontSize + 'px',
          'line-height': fontSize + 'px',
        }"
      >
        <div
          :style="{ color: starClass(star.class) }"
          style="
            border-left: 1px solid rgba(0, 0, 0, 0);
            border-right: 1px solid rgba(0, 0, 0, 0);
          "
        >
          {{ $t(star.name)[0] }}
        </div>
        <div :style="{ color: starClass(star.class) }">
          {{ $t(star.name)[1] }}
        </div>
        <div v-if="star.fourMode[0]" class="four-mode-life">
          {{ $t(star.fourMode[0]) }}
        </div>
        <div v-else class="four-mode">無</div>
        <div
          v-if="
            star.fourMode[1] &&
            (showState === 'YEARLY' || showState === 'DECADE')
          "
          class="four-mode four-mode-decade"
        >
          {{ $t(star.fourMode[1]) }}
        </div>
        <div v-else class="four-mode">無</div>
      </div>
    </div>
    <div
      style="
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
      "
    >
      <div
        style="display: flex; flex-direction: column; justify-content: flex-end"
      >
        <div>{{ palace.heavenlyName }}</div>
        <div>{{ palace.earthlyName }}</div>
      </div>
    </div>
    <div
      v-if="showState !== 'LIFE'"
      style="
        display: flex;
        flex-direction: row;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
      "
    >
      <div
        style="
          color: green;
          line-height: 14px;
          display: flex;
          flex-direction: column;
        "
        v-for="star in palace.decade.stars"
        :key="star"
      >
        <span style=""> 大 </span>
        <span style="">
          {{ $t(star[1]) }}
        </span>
      </div>
    </div>
    <div
      style="
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%, 0);
      "
    >
      <div style="font-size: 10px" v-if="showState === 'LIFE'">
        {{ palace.ageGap }}
      </div>
      <div style="margin-bottom: 1px">
        <div
          style="background-color: green; color: white"
          v-if="showState !== 'LIFE'"
        >
          {{ $t(palace.decade.palaceName) }}
        </div>
        <span style="color: white; background-color: red; padding: 1px">
          {{ $t(palaceName) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    palace: { type: Object },
    palaceId: null,
  },
  data() {
    return {
      fontSize: 14,
    }
  },
  mounted: function () {
    const resize_ob = new ResizeObserver(
      function () {
        if (this.fontSize <= 8) return

        // let rect = entries[0].contentRect
        // console.log(rect)

        // current width & height
        // let width = rect.width
        let width = (this.fontSize + 2) * this.palace.stars.length

        const wrapperWidth =
          document.getElementsByClassName('wrapper')[0].offsetWidth
        const cellWidth = wrapperWidth / 4 - 2
        if (width > cellWidth) {
          this.fontSize--
        }
      }.bind(this)
    )

    // start observing for resize
    resize_ob.observe(document.getElementById(this.componentId))
  },
  computed: {
    componentId: function () {
      return 'palace' + this.palaceId
    },
    thisWidth: function () {
      return document.getElementById(this.componentId).offsetWidth
    },
    palaceName: function () {
      if (this.palace.isBodyPalace === 1) {
        const PALACE_SHORT_NAME = {
          0: '命/身',
          1: '兄/身',
          2: '夫/身',
          3: '子/身',
          4: '财/身',
          5: '疾/身',
          6: '迁/身',
          7: '友/身',
          8: '事/身',
          9: '宅/身',
          10: '福/身',
          11: '父/身',
        }
        return PALACE_SHORT_NAME[this.palace.palaceId]
      }
      return this.palace.palaceName
    },
    showState: function () {
      return this.$parent.showState
    },
    stampCount: function () {
      let count = 0
      if (this.palace.yearly.palaceId == 0) {
        count++
      }
      if (this.palace.decade.palaceId == 0) {
        count++
      }
      return count
    },
  },
  methods: {
    starClass: function (classLevel) {
      const STAR_LEVEL_COLOR = {
        0: 'red',
        1: 'blueviolet',
        2: 'dodgerblue',
        3: 'black',
      }
      return STAR_LEVEL_COLOR[classLevel]
    },
    resetFontSize: function () {
      this.fontSize = 14
    },
  },
}
</script>

<style scoped>
.stars {
  font-size: 14px;
}
.stars-wrapper {
  display: flex;
  flex-direction: column;
}
.four-mode {
  color: rgba(0, 0, 0, 0);
  border-radius: 3px;
  border: 1px solid;
}
.four-mode-life {
  color: red;
  border: 1px solid red;
  border-radius: 6px;
}

.four-mode-decade {
  color: green;
  border: 1px solid green;
  border-radius: 6px;
}
</style>
